"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var cosmosBase_1 = __importDefault(require("./cosmosBase"));
var env_1 = require("../../../env");
var Cosmos = /** @class */ (function (_super) {
    __extends(Cosmos, _super);
    function Cosmos() {
        var _this = _super.call(this) || this;
        _this.unbondingPeriod = 21;
        _this.lcd = (0, env_1.getEnv)("API_COSMOS_BLOCKCHAIN_EXPLORER_API_ENDPOINT");
        _this.stakingDocUrl =
            "https://support.ledger.com/hc/en-us/articles/360014339340-Earn-Cosmos-ATOM-staking-rewards-in-Ledger-Live?docs=true";
        _this.minGasprice = 0.025;
        _this.validatorOperatorAddressPrefix = "cosmosvaloper";
        _this.ledgerValidator =
            "cosmosvaloper10wljxpl03053h9690apmyeakly3ylhejrucvtm";
        cosmosBase_1["default"].COSMOS_FAMILY_LEDGER_VALIDATOR_ADDRESSES.push(_this.ledgerValidator);
        return _this;
    }
    return Cosmos;
}(cosmosBase_1["default"]));
exports["default"] = Cosmos;
//# sourceMappingURL=Cosmos.js.map